import { TALUS_THRESHOLD, TALUS_PASSES } from "../config";

/**
 * Talus-style erosion. For each cell, find the lowest 4-neighbor; if the drop
 * is greater than `threshold`, decrement the cell by 1. Smooths cliffs without
 * touching gentle slopes.
 */
export function applyTalusErosion(
    heights: number[][],
    threshold: number = TALUS_THRESHOLD,
    passes: number = TALUS_PASSES,
): number[][] {
    const N = heights.length;
    for (let p = 0; p < passes; p++) {
        for (let x = 0; x < N; x++) {
            for (let z = 0; z < N; z++) {
                let lowest = heights[x][z];
                if (x > 0) lowest = Math.min(lowest, heights[x - 1][z]);
                if (x < N - 1) lowest = Math.min(lowest, heights[x + 1][z]);
                if (z > 0) lowest = Math.min(lowest, heights[x][z - 1]);
                if (z < N - 1) lowest = Math.min(lowest, heights[x][z + 1]);
                if (heights[x][z] - lowest > threshold) {
                    heights[x][z] -= 1;
                }
            }
        }
    }
    return heights;
}
